document.addEventListener("DOMContentLoaded", function () {
  function notifyFavoriteProductsError(message, detail) {
    fetch("/apps/favorite-collections/api/notify-favorite-products-error", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: message,
        detail: detail,
      }),
    }).catch(() => {});
  }

  const checkbox = document.getElementById("mx-optout-checkbox-custom");
  if (checkbox) {
    checkbox.addEventListener("change", function (event) {
      const customerId = event.target.dataset.customerId;
      if (!customerId) {
        return;
      }

      fetch("/tools/prime-review/api/optout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId: customerId,
          optout: event.target.checked ? "false" : "true",
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`optout API failed with status ${response.status}`);
          }
        })
        .catch((error) => {
          notifyFavoriteProductsError("Failed to update optout setting", {
            customerId: customerId,
            error: String(error),
          });
          console.error("Failed to update optout setting:", error);
        });
    });
  }

  // all_products の上限を超えてサーバー側で描画できなかったアイテム（プレースホルダー）を、
  // Section Rendering API で favorite-product-item セクションを取得して差し替える。
  const favoriteList = document.querySelector("[data-custom-favorite-list]");
  const rootUrl =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";

  async function loadFavoritePlaceholder(placeholder) {
    const handle = placeholder.dataset.handle;
    const variantId = placeholder.dataset.variantId;
    const url = `${rootUrl}products/${encodeURIComponent(handle)}?variant=${encodeURIComponent(variantId)}&section_id=favorite-product-item`;

    try {
      const response = await fetch(url);
      // 商品が削除・非公開になっている場合は404になるので、サーバー側描画と同様に表示しない
      if (response.status === 404) {
        placeholder.remove();
        return true;
      }
      if (!response.ok) {
        throw new Error(
          `favorite-product-item section failed with status ${response.status}`,
        );
      }

      const html = await response.text();
      const item = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".custom-favorite-list__item");
      if (!item) {
        // バリアントが存在しない場合はセクションが空で返る
        placeholder.remove();
        return true;
      }
      item.style.display = placeholder.style.display;
      placeholder.replaceWith(item);
      return false;
    } catch (error) {
      notifyFavoriteProductsError("Failed to load favorite product", {
        handle: handle,
        variantId: variantId,
        error: String(error),
      });
      console.error("Failed to load favorite product:", error);
      const message = placeholder.querySelector(
        ".custom-favorite-list__placeholder-message",
      );
      if (message) {
        message.innerText =
          "読み込みに失敗しました。時間をおいて再度お試しください。";
      }
      return false;
    }
  }

  async function loadVisibleFavoritePlaceholders() {
    if (!favoriteList) {
      return;
    }
    const placeholders = Array.prototype.filter.call(
      favoriteList.querySelectorAll(
        "[data-favorite-placeholder]:not([data-loading])",
      ),
      (placeholder) => placeholder.style.display !== "none",
    );
    if (placeholders.length === 0) {
      return;
    }
    placeholders.forEach((placeholder) => {
      placeholder.dataset.loading = "true";
    });

    const results = await Promise.all(
      placeholders.map(loadFavoritePlaceholder),
    );
    // 表示できないアイテムを取り除いた場合は件数が変わるので、ページングを再計算する
    if (
      results.some((removed) => removed) &&
      window.refreshFavoriteListPagination
    ) {
      window.refreshFavoriteListPagination();
    }
  }

  if (favoriteList) {
    if (document.querySelector("[data-favorite-list-pagination]")) {
      favoriteList.addEventListener(
        "favorite-list:page-shown",
        loadVisibleFavoritePlaceholders,
      );
      // ページングの初期化が先に終わっている場合は初回のイベントを受け取れないため、ここで表示中のページ分を読み込む。
      // 初期化前（全件が表示状態）に読み込むと全件を取得してしまうため、初期化済みの場合に限る。
      if (favoriteList.dataset.paginationReady === "true") {
        loadVisibleFavoritePlaceholders();
      }
    } else {
      loadVisibleFavoritePlaceholders();
    }
  }

  function decrementFavoritesCount() {
    const floatCountDiv = document.getElementById(
      "prime-review-favorites-count",
    );
    if (!floatCountDiv) {
      return;
    }
    const count = (Number(floatCountDiv.innerText) || 0) - 1;
    floatCountDiv.innerText = String(count);
    floatCountDiv.style.display = count > 0 ? "block" : "none";
  }

  window.handleRemoveFavorite = async function (target) {
    if (!confirm("お気に入りから外しますか？")) {
      return;
    }

    const handle = target.dataset.handle;
    const variantId = target.dataset.variantId;
    const customerId = target.dataset.customerId;

    let processMessage = target.parentNode.querySelector(
      ".mxpr-favorites-process-message",
    );
    if (!processMessage) {
      processMessage = document.createElement("div");
      processMessage.classList.add("mxpr-favorites-process-message");
      target.parentNode.appendChild(processMessage);
    }
    processMessage.innerText = "削除中...";
    target.style.display = "none";

    try {
      const response = await fetch("/tools/prime-review/api/removeFavorite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          handle: handle,
          variant: variantId,
          customerId: customerId,
        }),
      });

      if (!response.ok) {
        throw new Error(
          `removeFavorite API failed with status ${response.status}`,
        );
      }
    } catch (error) {
      notifyFavoriteProductsError("Failed to remove favorite", {
        handle: handle,
        variantId: variantId,
        customerId: customerId,
        error: String(error),
      });
      console.error("Failed to remove favorite:", error);
      processMessage.innerText =
        "削除に失敗しました。時間をおいて再度お試しください。";
      target.style.display = "";
      return;
    }

    decrementFavoritesCount();

    const item = target.closest("li");
    const list = document.querySelector("[data-custom-favorite-list]");
    if (item) {
      item.remove();
    }

    if (
      list &&
      list.querySelectorAll(".custom-favorite-list__item").length === 0
    ) {
      // 最後の1件を削除した場合、サーバーでレンダリングされた「空」の文言はもう無いため、JS側で表示する。
      const footer = document.querySelector(".custom-favorite-list__footer");
      if (footer) {
        footer.remove();
      }
      const emptyMessage = document.createElement("p");
      emptyMessage.classList.add("custom-favorite-list__empty");
      emptyMessage.innerText = "お気に入りの商品はありません。";
      list.replaceWith(emptyMessage);
      return;
    }

    if (window.refreshFavoriteListPagination) {
      window.refreshFavoriteListPagination();
    }
  };
});
